export default "/images/es.png?21cf5684f638bbe7bf6fa39fa5694ea0";